export default __webpack_public_path__ + "static/media/ktp900.3656e59e.png";